import React from 'react';
import { NavLink } from 'react-router-dom';

//Bootstrap
import { Container, Row, Col } from 'react-bootstrap';

import './HomeCardAbout.css';
import CountUp from 'react-countup';

const HomeCardAbout = (props) => {
    return (
        <Container fluid className="p-5 text-left">
            <Row className="mx-md-5">
                <Col lg="6" className="px-md-5 pt-lg-5 align-items-center d-flex">
                    <img src={props.img} className="img-fluid" alt="" />
                </Col>
                <Col lg="6" className="px-md-5 pt-5">
                    <h1 className="custom-weight-bolder custom-text-black">{props.title}</h1>
                    {props.description}
                    <Row className="custom-text-black pt-4">
                        <Col>
                            <CountUp suffix="+" end={props.stats1.value} duration={3} className="custom-countup pt-5" />
                            <p className="custom-weight-lighter pt-2">{props.stats1.label}</p>
                        </Col>
                        <Col>
                            <CountUp suffix="" end={props.stats2.value} duration={3} className="custom-countup pt-5" />
                            <p className="custom-weight-lighter pt-2">{props.stats2.label}</p>
                        </Col>
                    </Row>
                    <Row className="custom-text-black pt-4 d-flex justify-content-center">
                        <Col className="px-3">
                            <div className="">
                                <NavLink to={{ pathname: "/sobremi" }} className="btn custom-btn py-2 px-3">Sobre Mí</NavLink>
                            </div>
                            <div className="pt-3">
                                <NavLink to={{ pathname: "/contacto" }} className="btn custom-btn py-2 px-3">Contactarme</NavLink>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

export default HomeCardAbout;